export const SET_RTT_REFERENCES = 'SET_RTT_REFERENCES';